import { getAxiosClient } from '~src/api';
import { modifyState } from '~src/state';
import { onErrorShowMessage } from '~src/errors';

export const fetchMediaFiles = async () => {
  const httpClient = await getAxiosClient();

  try {
    const response = await httpClient.get(
      `${process.env.GIOTTO_VIDEO_CDN}/media/media.json`
    );

    modifyState('videoMediaFiles', response.data);
  } catch (error) {
    console.error('Error in fetching video media files', error);
    onErrorShowMessage();
  }
};
